/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Block_Third_Country_BodyInputs */



/**
* | output |
* | --- |
* | "Outside the EU — tax-free as a third-country export. Confirmed, but not yet mapped in the accounting system. Amounts keep accruing." |
*
* @param {Partner_Detail_Block_Third_Country_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_block_third_country_body = /** @type {((inputs?: Partner_Detail_Block_Third_Country_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Block_Third_Country_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Außerhalb der EU — steuerfrei als Drittlandausfuhr. Bestätigt, aber noch nicht in der Buchhaltung abgebildet. Die Beträge laufen weiter auf.")
	return /** @type {LocalizedString} */ ("Outside the EU — tax-free as a third-country export. Confirmed, but not yet mapped in the accounting system. Amounts keep accruing.")
});